"use strict";
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGrouplessAccount = exports.isGroupedAccount = exports.isGrouplessKeyType = exports.isGroupedKeyType = exports.keyTypes = exports.grouplessKeyTypes = exports.groupedKeyTypes = void 0;
const utils_1 = require("../utils");
utils_1.assertType;
exports.groupedKeyTypes = ['default', 'bip340-schnorr'];
exports.grouplessKeyTypes = ['gl-secp256k1', 'gl-secp256r1', 'gl-ed25519', 'gl-webauthn'];
exports.keyTypes = [...exports.groupedKeyTypes, ...exports.grouplessKeyTypes];
function isGroupedKeyType(keyType) {
    return keyType === 'default' || keyType === 'bip340-schnorr';
}
exports.isGroupedKeyType = isGroupedKeyType;
function isGrouplessKeyType(keyType) {
    return keyType !== 'default' && keyType !== 'bip340-schnorr';
}
exports.isGrouplessKeyType = isGrouplessKeyType;
function isGroupedAccount(account) {
    return isGroupedKeyType(account.keyType);
}
exports.isGroupedAccount = isGroupedAccount;
function isGrouplessAccount(account) {
    return isGrouplessKeyType(account.keyType);
}
exports.isGrouplessAccount = isGrouplessAccount;
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
utils_1.assertType;
(0, utils_1.assertType)();
